<mat-form-field style="margin: 2vh 0; width: 100%" appearance="outline">
  <mat-label> Auswahl der Übergruppe (A-U)</mat-label>
  <mat-select [formControlName]="naceMapControlName">
    <mat-option>
      <ngx-mat-select-search
        [formControlName]="naceMapControlName"
      ></ngx-mat-select-search>
    </mat-option>
    @for (naceMap of filteredNaceMaps; track naceMap) {
      <mat-option [value]="naceMap.key">
        {{ naceMap.key }}
      </mat-option>
    }
  </mat-select>
  @if (
    formGroup.get(naceMapControlName).invalid &&
    formGroup.get(naceMapControlName).touched
  ) {
    <mat-error> Übergruppe muss angegeben werden. </mat-error>
  }
</mat-form-field>
